import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
import theme from '@ep/theme';
import { Link as GatsbyLink } from 'gatsby';
import React from 'react';

export interface LinkProps extends React.HTMLAttributes<HTMLAnchorElement> {
  to: string;
  bold?: boolean;
  nofollow?: boolean;
}

function UniversalLink({ to, nofollow, ...rest }: LinkProps) {
  if (to && to.startsWith('/')) {
    if (nofollow) {
      return <GatsbyLink to={to} rel="nofollow" {...rest} />;
    }
    return <GatsbyLink to={to} {...rest} />;
  }

  if (to && to.startsWith('#')) {
    return <a href={to} {...rest} />;
  }

  if (to && nofollow) {
    return <a href={to} target="_blank" rel="nofollow" {...rest} />;
  }

  return <a href={to} target="_blank" rel="noopener" {...rest} />;
}

export const Link = styled(React.memo(UniversalLink), {
  shouldForwardProp: prop =>
    (isPropValid(prop) && prop !== 'bold') ||
    prop === 'nofollow' ||
    prop === 'state',
})<LinkProps>`
  text-decoration: none;
  ${({ bold }) =>
    bold
      ? `
        display: inline-block;
        font-family: ${theme.typography.primaryFont.bold};
        font-weight: bold;
        font-size: ${theme.typography.toRem(18)};
        color: ${theme.colors.mediumBlue};
      `
      : `
        color: ${theme.colors.darkBlue};
        font-family: ${theme.typography.primaryFont.regular};
        :hover {
          text-decoration: underline;
        }
      `}
`;

export default Link;
